import {
  loginReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
} from "../reducers/onboarding/outbound.reducer";

import {
  createStoreProductReducer,
  uploadStoreBulkProductsReducer,
  updateStoreProductReducer,
  getProductMetaDataReducer,
  getImageGalleryReducer,
  uploadProductImageReducer,
  getImageReducer,
  downloadImageReducer,
  deleteImageReducer,
  updateProductImageReducer,
  getStoresListReducer,
  updateStoreReducer,
  getTopStoresReducer,
  getOrderListReducer,
  getOrderDetailsReducer,
  getProductsListReducer,
  getStoreDetailsReducer,
  getStoreTransactionsReducer,
  getCustomersReducer,
  getCustomersListReducer,
  customerCsvExportReducer,
  getVendorsReducer,
  getVendorDetailsReducer,
  getStoreChartReducer,
  getAProductReducer,
  getDashboardSummaryReducer,
  getDashboardBottomOneReducer,
  getDashboardBottomTwoReducer,
  getVendorSummaryReducer,
  getProductsSummaryReducer,
  getACustomerAddressReducer,
  toggleUserReducer,
  toggleStoreReducer,
  addNewStoreReducer,
  getStoreCategoriesReducer,
  getStoreCategoryReducer,
  updateStoreCategoryReducer,
  createStoreCategoryReducer,
  updateStoreGroupReducer,
  getStoreGroupsReducer,
  getStoreGroupReducer,
  createStoreGroupReducer,
  deleteStoreCategoryReducer,
  deleteStoreGroupReducer,
  getUrlReducer,
  updateVersionReducer,
  getVersionsReducer,
  createVersionReducer,
} from "../reducers/inapp/inapp.reducer";

import {
  getCustomerDetailsReducer,
  updateCustomerReducer,
  getCustomerOrdersReducer,
  getCustomerTotalSpentReducer,
  getCustomerStoresReducer,
} from "../reducers/inapp/customers";

export const inAppReducers = {
  createStoreProductReducer,
  uploadStoreBulkProductsReducer,
  updateStoreProductReducer,
  getProductMetaDataReducer,

  getImageGalleryReducer,
  uploadProductImageReducer,
  updateProductImageReducer,
  getImageReducer,
  downloadImageReducer,
  deleteImageReducer,

  getStoresListReducer,
  getTopStoresReducer,
  getOrderListReducer,
  getOrderDetailsReducer,
  getProductsListReducer,
  getStoreDetailsReducer,
  getStoreTransactionsReducer,
  getCustomersReducer,
  getCustomersListReducer,
  customerCsvExportReducer,
  getVendorsReducer,
  getVendorDetailsReducer,
  getStoreChartReducer,
  getAProductReducer,

  getDashboardSummaryReducer,
  getDashboardBottomOneReducer,
  getDashboardBottomTwoReducer,
  getVendorSummaryReducer,
  getProductsSummaryReducer,
  getACustomerAddressReducer,

  toggleUserReducer,
  toggleStoreReducer,

  addNewStoreReducer,
  getStoreCategoriesReducer,
  getStoreCategoryReducer,
  createStoreCategoryReducer,
  updateStoreCategoryReducer,
  deleteStoreCategoryReducer,
  getStoreGroupReducer,
  getStoreGroupsReducer,
  createStoreGroupReducer,
  updateStoreGroupReducer,
  deleteStoreGroupReducer,
  getUrlReducer,
  updateStoreReducer,
  updateVersionReducer,
  getVersionsReducer,
  createVersionReducer,

  // Customer management reducers
  getCustomerDetailsReducer,
  updateCustomerReducer,
  getCustomerOrdersReducer,
  getCustomerTotalSpentReducer,
  getCustomerStoresReducer,

  // Blog reducers will be added when API is ready
};

export const outboundReducers = {
  loginReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
};
